import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/montserrat';
import '@fontsource-variable/hanken-grotesk';
import './styles.css';
import { App } from './App';
import { initPlayerEngine } from './player/engine';
import { initAppearance } from './lib/appearance';

initAppearance();
initPlayerEngine();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
